import React from 'react';
import { inject, observer } from 'mobx-react';
import { Badge, Tooltip, Button, Dropdown, Menu, Modal, message } from 'antd';
import { CaretDownFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import { i18nTranslate } from "@didi/i18n-plugin";
import { dealCurrentStatus,  deleteTicketState } from './utils'
import { WORK_BENTH_TICKET_TYPE } from './config'
import moment from 'moment';
import {
  getStatusInit2,
  changeStatusV2,
  keepAlive2,
  getViewByViewName,
  genesysMapping,
  genesysUserDetails,
  getActionRecord,
  getGenesysOutofoffice,
} from '@/common/js/api'
import { SET_WORKBENCH_VERSION} from '@/common/js/const';
import './index.less'
import actions from "@/shared/actions";
import CommonStore from '@/stores/commonStore';
import IconFont from '@/common/utils/iconfont'
import { trackClickEvent } from '@/common/js/omega'
import { setCookie, getCookie } from '../../common/utils/commonFunc';
import { color, getTime } from './config';
import ServiceTypeToast from './service-type-toast';

interface WorkingStatusProps {
  CommonStore?: typeof CommonStore;
  CSVersion: Boolean;
}
@inject('CommonStore')
@observer
class workingStatus extends React.Component<WorkingStatusProps, any> {

  countStartTime: number = 0;
  durationTiming: number = -1;
  keepAliveTiming: number = -1;
  numTiming: number = -1;
  ticketTiming: number = -1;
  hasOperation: boolean = false; // 客服有操作就传 true，没操作传false
  defaultStatusAfterLogin: number = 100;
  count: number = 0;
  timeoutNum: number = 5;

  constructor(props: WorkingStatusProps) {
    super(props);
    this.state = {
      validStatusSet: [],
      currentStatus: '',
      currType: 0,
      currentTicketStatus: -1,
      currentPhoneStatus: -1,
      targetStatus: '',
      validStatusMap: {},
      validTicketStatusSet: [],
      visibleChangeModal: false,
      visibleBreakModal: false,
      duration: 0,
      showTicketNum: false,
      ticketNumber: 0,
      old_ticketNumber: 0,
      currentOnlineChatStatus: -1,
      validOnlineChatStatusSet: [],
      autoChangeModalVisible: false,
      phoneIsChangeStatus: true,
      ark2genesys: {},
      genesys2ark: {},
      validTStatusSet: {},
      validOStatusSet: {},
      validPhoneStatusSet: {},
      currentStatusMap: {},
      ticketStatusActive: (!window.location.href.includes('/ark/genesys') && !(window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard'))), // 异步工作台
      onlineStatusActive: window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard'),
      phoneStatusActive: window.location.href.includes('/ark/genesys'),
      currentList: {},
      currentOnlineChatKey: 100,
      currentTicketKey: 100,
      currentPhoneKey: 100,
      changeModalTitle: 1, // 1： 在线/ 离线/ 话后处理 切为 会议/ 培训/ 休息/ 厕所/ 吃饭 时文案
      // 2： 会议/ 培训/ 休息/ 厕所/ 吃饭 切为 在线/ 离线/ 话后处理 时文案
      timeoutModalVisible: false,
      timeoutThreshold: 30,
      num: this.timeoutNum, // 倒计时
      workbenchTypeOnlineChatStartTimestamp: 0,
      workbenchTypePhoneStartTimestamp: 0,
      workbenchTypeTicketStartTimestamp: 0,
      // timeoutMessageWarn: false, // 超时提醒超过5s后下线提醒
      rtt: 1,
      onLine: true,
      dropdownVisible: false,
      genesysOrganization: 'didiglobal1',

      changeWorkbenchStatusFromWorkbench: false,  //仅用来作用于配合子系统2.1工单处理点击开始工作按钮时，基座系统与子系统之间状态传递的标识
    };
  }

  componentDidMount() {
    const self = this
    actions.onGlobalStateChange((state, prev)=>{
      if(state.changeWorkbenchStatus === 'trigger' && state.changeWorkbenchStatus !== prev.changeWorkbenchStatus){
        // 仅用来作用于配合子系统2.1工单处理点击开始工作按钮时，将基座系统与子系统之间状态传递控制触发基座开始工作方法的标识
        self.setState({
          changeWorkbenchStatusFromWorkbench: true
        })
        self.startWorking()
      }
      // if(state.currentTicketStatus === 100 && state.currentTicketStatus !== prev.currentTicketStatus){
      //   self.startWorking()
      // }
    })
    // 工作状态初始化
    this.getStatusInit();
    // 获取网络条件
    this.getNetStatus();
    // 切换浏览器tab
    if (document.hidden !== undefined && window.self === window.top) {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden === false) {
          this.keepAlive('tab_show');
        }
      })
    }
    clearInterval(this.keepAliveTiming)
    this.keepAliveTiming = window.setInterval(() => {
      this.keepAlive()
    }, 60000);
    // 是否有点击事件
    // window.addEventListener('click', () => {
    //   this.hasOperation = true
    // });
    // 获取浏览器刷新时间
    // window.addEventListener('beforeunload', () => {
    //   if (this.state.timeoutMessageWarn) {
    //     message.warn('由于超时未操作，状态已自动变为离线状态，请刷新页面。');
    //   }
    // })
    window.addEventListener("message", (event) => {// 接受genesys的状态
      if (event.data && typeof event.data === 'string') {
        let sendMessage = JSON.parse(event.data);
        if (sendMessage.type === 'hasOperation' && sendMessage.data.status) {
          this.hasOperation = true;
        }
        if (sendMessage.type === "updateUserStatus" && sendMessage.data) {
          const newStatus = ((sendMessage.data.id === '' || sendMessage.data.id === 'OUT_OF_OFFICE')) ? 1000 :
          this.state.targetStatus === 600 ? 600 :
          this.state.genesys2ark[sendMessage.data.id];
          this.setState({
            // currentStatus: Number(newStatus),
            // targetStatus: Number(newStatus),
            phoneIsChangeStatus: false,
          });
          const param = {
            workbenchType: 3,
            targetStatus: newStatus,
            misName: this.props.CommonStore?.UserInfo.username,
            javaLang: getCookie("lang").replace("-", "_")
          }
          if (param.targetStatus && (this.state.targetStatus !== Number(newStatus))) {
            changeStatusV2(param).then((res: any) => {
              if (res.status === 0) {
                this.init_data(res.data.staffStatusInfo, 100);
                this.setState({
                  targetStatus: res.data.staffStatusInfo.currentStatus,
                });
              } else {
                if (res.error) {
                  message.info(res.error);
                }
              }
            });
          }
        }

        
        if (sendMessage.type === "loginUserStatus" && sendMessage.data.status) {
          this.setState({
            phoneIsChangeStatus: false,
          });
        }
      }
    });
    this.getViewByViewName()
    trackClickEvent('ibt_cs_page_change_page_sw',{"workbench_version" : SET_WORKBENCH_VERSION()})
    this.getGenesysMapping(); // 电话工作台id与客服状态的映射
  }

  // 网速部分
  getNetStatus = () => {
    if (navigator.connection) {
        const connection: any = navigator.connection;
        let rtt = connection.rtt;
        let onLine = navigator.onLine;
        connection.onchange = () => {
            rtt = connection.rtt;
            onLine = navigator.onLine;
            let t = 180;
            if (!onLine) {
              let timer = window.setInterval(() => {
                t--;
                if (t < 0) {
                  clearInterval(timer);
                  this.setState({
                    currentStatusMap: {1: 1000, 2: 1000, 3: 1000},
                    currentStatus: 1000,
                    currType: 4,
                    visibleBreakModal: true,
                    dropdownVisible: false
                  });
                  return;
                }
              }, 1000)
            }
            this.setState({
              rtt,
              onLine,
            })
        }
        this.setState({
          rtt,
          onLine,
        })
    }
  }

  changeTimeoutConfirm = () => {
    const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
    const TEXTS = this.props.CommonStore!.curLocales || {}
    this.setState({
      timeoutModalVisible: true,
      num: this.timeoutNum,
    }, () => {
      if (this.state.num > 0) {
        clearInterval(this.numTiming);
        this.numTiming = window.setInterval(() => {
            this.setState({
              num: this.state.num - 1,
            }, () => {
              if (this.state.num === 0) {
                clearInterval(this.numTiming);
                this.setState({
                  timeoutModalVisible: false,
                  targetStatus: 1000,
                  // timeoutMessageWarn: true,
                }, () => {
                  this.changeStatus(100);
                  message.warn(TEXTS['CS_optimazation__CALn'])
                  if (this.state.currType === 1) {
                    this.setCurrentStatus(newSubStatustType, 1000, 1000, 1000);
                  }
                });
              }
              if (this.state.num < 0) {
                clearInterval(this.numTiming);
              }
            });
        }, 1000);
      }
    });
  };

  getGenesysMapping = () => {
    // 获取组织
    genesysUserDetails().then((res: any) => {
      if (res && res.data && res.status === 0) {
        const { list } = res.data;
        let myGenesysOrg = localStorage.getItem("genesysOrganization")
        let onGenesysOrg = list[0].genesysOrganization
        if(!myGenesysOrg && onGenesysOrg){
          myGenesysOrg = onGenesysOrg 
          localStorage.setItem("genesysOrganization",onGenesysOrg)
        }
        myGenesysOrg = myGenesysOrg ? myGenesysOrg : 'didilatam'
        this.setState({
          genesysOrganization: myGenesysOrg
        });
        genesysMapping({genesysOrg : myGenesysOrg}).then((res: any) => {
          if (res && res.status === 0) {
            const { ark2genesys, genesys2ark, genesysOrg } = res.data;
            this.setState({
              ark2genesys: JSON.parse(ark2genesys),
              genesys2ark: JSON.parse(genesys2ark),
              // genesysOrganization: genesysOrg,
            });
          }
        });
      }
    })
  };

  // 初始化
  getStatusInit = () => {
    getStatusInit2({
      misName: this.props.CommonStore?.UserInfo.username,
      javaLang: getCookie("lang").replace("-", "_")
    }).then((res: any) => {
      if (res.status === 0) {
        let data = res.data.staffStatusInfo
        this.init_data(data, 100)
      } else {
        if (res.error) {
          message.info(res.error);
        }
      }
    })
  }

  // 通用函数
  init_data = (staffStatusInfo: { currentOnlineChatStatus: number; validStatusSet: any; currentStatus: number;
    validTicketStatusSet: any; currentTicketStatus: number; currentPhoneStatus: number; validOnlineChatStatusSet: any; defaultStatusAfterLogin: number;
    nowTimestamp: number; validStatusList: any; currentStatusMap: any; popShow: any;
    timeoutThreshold: any; workbenchTypeOnlineChatStartTimestamp: number;
    workbenchTypePhoneStartTimestamp: number; workbenchTypeTicketStartTimestamp: number;
    lastOnlineChatOperationTimestamp: number;
    lastPhoneOperationTimestamp: number;
    lastTicketOperationTimestamp: number; }, type: number) => {
      
      this.setState({
        currentStatusMap: staffStatusInfo.currentStatusMap,
        timeoutThreshold: staffStatusInfo.timeoutThreshold,
      });
      if (staffStatusInfo.popShow) {
        this.changeTimeoutConfirm();
      }
      let newValidTStatusSet: any, newValidOStatusSet: any, newValidPhoneStatusSet: any = {};
      const { ticketStatusActive, onlineStatusActive, phoneStatusActive } = this.state;
      let newCurrentList: any = {};
      let newCurrentStatus: number = 1000;
      let validStatusMap = {}
      staffStatusInfo.validStatusList.forEach((one: any) => {
        switch(one.workbenchType) {
          case 1: 
            this.setState({
              validTStatusSet: one,
            });
            return newValidTStatusSet = one;
          case 2:
            this.setState({
              validOStatusSet: one,
            });
            return newValidOStatusSet = one;
          case 3:
            this.setState({
              validPhoneStatusSet: one,
            });
            return newValidPhoneStatusSet = one;
        }
      });
    actions.setGlobalState({ currentOnlineChatStatus: staffStatusInfo.currentOnlineChatStatus });
    setCookie('currentOnlineChatStatus', staffStatusInfo.currentOnlineChatStatus, 24);
    let currType = 0
    if (ticketStatusActive) {
      // 异步工作台
      newCurrentList = newValidTStatusSet;
      JSON.parse(newValidTStatusSet.value).forEach((element: { key: number; title: string; type: number; }) => {
        validStatusMap[element.key] = element.title;
        if (element.key === staffStatusInfo.currentStatusMap['1']) {
          currType = element.type
        }
      });
      newCurrentStatus = staffStatusInfo.currentStatusMap['1'];
      //  改变后的状态通知叫号系统
      localStorage.setItem('newCurrentStatus', newCurrentStatus + '');
    }
    if (onlineStatusActive) {
      // 在线工作台
      newCurrentList = newValidOStatusSet;
      JSON.parse(newValidOStatusSet.value).forEach((element: { key: number; title: string; type: number; }) => {
        validStatusMap[element.key] = element.title;
        if (element.key === staffStatusInfo.currentStatusMap['2']) {
          currType = element.type
        }
      });
      if (staffStatusInfo.currentOnlineChatStatus === 121) {
        if (staffStatusInfo.currentStatusMap['2'] === 100) {
          newCurrentStatus = 100;
        } else {
          newCurrentStatus = staffStatusInfo.currentStatusMap['2'];
        }
      } else {
        newCurrentStatus = staffStatusInfo.currentStatusMap['2'];
      }
    }
    if (phoneStatusActive) {
      // 电话工作台
      newCurrentList = newValidPhoneStatusSet;
      JSON.parse(newValidPhoneStatusSet.value).forEach((element: { key: number; title: string; type: number; }) => {
        validStatusMap[element.key] = element.title;
        if (element.key === staffStatusInfo.currentStatusMap['3']) {
          currType = element.type
        }
      });
      newCurrentStatus = staffStatusInfo.currentStatusMap['3'];
    }
    this.setState({
      validStatusMap,
      currentList: newCurrentList,
      currentStatus: newCurrentStatus,
      // targetStatus: newCurrentStatus,
      currType,
      validStatusSet: staffStatusInfo.validStatusSet,
      validTicketStatusSet: staffStatusInfo.validTicketStatusSet,
      currentTicketStatus: staffStatusInfo.currentTicketStatus,
      currentPhoneStatus: staffStatusInfo.currentPhoneStatus,
      currentOnlineChatStatus: staffStatusInfo.currentOnlineChatStatus,
      validOnlineChatStatusSet: staffStatusInfo.validOnlineChatStatusSet,
      // visibleBreakModal: newCurrentStatus !== 1000 ? false : true,
    }, () => {
      if (this.state.currType === 3 || this.state.currType === 4) {
        this.setState({
          visibleBreakModal: true,
          dropdownVisible: false
        });
      } else {
        this.setState({
          visibleBreakModal: false
        })
      }
    })
    if (this.state.currentTicketStatus !== -1) {
      clearInterval(this.ticketTiming)
      this.ticketTiming = window.setInterval(() => {
        this.getViewByViewName()
      }, 60000)
    }
    if (staffStatusInfo.currentTicketStatus !== -1 || staffStatusInfo.currentOnlineChatStatus !== -1 || staffStatusInfo.currentPhoneStatus !== -1) {
      this.props.CommonStore!.setSubStatus(true)
    } else {
      this.props.CommonStore!.setSubStatus(false)
    }
    if (!this.state.targetStatus) {
      this.setState({
        targetStatus: staffStatusInfo.currentStatus,
      })
    }
    this.setTime(staffStatusInfo, type)
  }
  // 监控页面状态实时更新
  keepAlive = (type?: string) => {
    const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
    keepAlive2({
      hasOperation: this.hasOperation,
      workbenchType: newSubStatustType,
      misName: this.props.CommonStore?.UserInfo.username,
    }).then((res: any) => {
      if (res.status === 0) {
        if (res.data) {
          this.hasOperation = false;
          let staffStatusInfo = res.data.staffStatusInfo
          // if (staffStatusInfo.currentStatus !== this.state.currentStatus || type === 'tab_show') {
          if (this.state.currentStatus === 400 || this.state.currentStatus === 500 || this.state.currentStatus === 600) {
            this.init_data(staffStatusInfo, 300)
          } else {
            this.init_data(staffStatusInfo, 100)
          }
          // }
          if (staffStatusInfo.currentStatus === 100) {
            this.setState({
              visibleBreakModal: false
            })
          }
          if (newSubStatustType === 3) {
            window.parent.postMessage( // 传给genesys的状态
              JSON.stringify({
                type: "setTargetStatus",
                data: { id: this.state.ark2genesys[staffStatusInfo.currentStatus.toString()]  }
              }),
              "*"
            );
            if (staffStatusInfo.currentStatus === 1000) {
              getGenesysOutofoffice({ 
                endDate: moment().startOf('hour').add(1, 'day'),
                startDate: moment().startOf('hour'),
                genesysOrganization: this.state.genesysOrganization,
              })
            }
          }
        }
      } else {
        if (res.error) {
          message.info(res.error);
        }
      }
    })
  }
  // 获取ticketNum
  getViewByViewName = () => {
    let param = {
      viewName: 'my_waiting_tickets',
      fieldName: 'view_name',
      userId: this.props.CommonStore!.Cookies.userid,
      lang: getCookie("lang").replace("-", "_"),
    }

    getViewByViewName(param).then((res) => {
      if (res.status === 0 && res.data.data.length) {
        let old_ticketNumber = this.state.ticketNumber
        let ticketNumber = res.data.data[0] ? res.data.data[0].total : 0
        this.setState({
          ticketNumber,
          old_ticketNumber
        })
        if (ticketNumber > old_ticketNumber) {
          this.setState({
            showTicketNum: true
          })
        } else {
          this.setState({
            showTicketNum: false
          })
        }
      }
    })
  }

  // 设置工作时间
  setTime = (data: { nowTimestamp: number; workbenchTypeOnlineChatStartTimestamp: number;
    workbenchTypePhoneStartTimestamp: number; workbenchTypeTicketStartTimestamp: number;
    lastOnlineChatOperationTimestamp: number;
    lastPhoneOperationTimestamp: number;
    lastTicketOperationTimestamp: number; }, type: number) => {
    if (!data) return
    let time_init = data.nowTimestamp - data.workbenchTypeTicketStartTimestamp;
    const { ticketStatusActive, onlineStatusActive, phoneStatusActive } = this.state;
    if (ticketStatusActive) {
      // 异步工作台
      if (type === 300) {
        time_init = data.nowTimestamp - data.lastTicketOperationTimestamp;
      } else {
        time_init = data.nowTimestamp - data.workbenchTypeTicketStartTimestamp;
      }
    }
    if (onlineStatusActive) {
      // 在线工作台
      if (type === 300) {
        time_init = data.nowTimestamp - data.lastOnlineChatOperationTimestamp;
      } else {
        time_init = data.nowTimestamp - data.workbenchTypeOnlineChatStartTimestamp;
      }
    }
    if (phoneStatusActive) {
      // 电话工作台
      if (type === 300) {
        time_init = data.nowTimestamp - data.lastPhoneOperationTimestamp;
      } else {
        time_init = data.nowTimestamp - data.workbenchTypePhoneStartTimestamp;
      }
    }
    let duration = Math.round(time_init / 1000)
    this.setState({
      duration
    })
    this.count = 0
    this.countStartTime = new Date().getTime()
    setTimeout(this.fixedTime, 1000);
    clearTimeout(this.durationTiming)
  }

  fixedTime = () => {
    this.setState({
      duration: this.state.duration + 1
    }, () => {
      this.count++
      var offset = new Date().getTime() - (this.countStartTime + this.count * 1000);
      var nextTime = 1000 - offset;
      if (nextTime < 0) nextTime = 0;
      this.durationTiming = window.setTimeout(this.fixedTime, nextTime);
    })
  }

  modalVisible = (value: boolean) => {
    this.setState({
      visibleChangeModal: value
    })
  }

  // 切换工作状态
  changeStatusModal = (key: number, type: number, workbenchType: number) => {
    const { phoneIsChangeStatus } = this.state;
    const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
    if (phoneIsChangeStatus && newSubStatustType === 3) { // 状态切换失败，请登录Genesys系统
      message.error(this.props.CommonStore!.curLocales['CS_optimazation_The_status_hqOj']);
      return;
    }
    const arr = [100, 110, 1000]; // 在线/ 离线/ 话后处理 
    const list = [200, 300, 400, 500, 600, 210, 710, 720, 730, 740, 750]; // 会议/ 培训/ 休息/ 厕所/ 吃饭
    if (key !== this.state.currentStatus) {
      this.setState({
        targetStatus: key,
        // timeoutMessageWarn: false,
      })
      if ((list.includes(this.state.currentStatus) && list.includes(key)) || (
        arr.includes(this.state.currentStatus) && arr.includes(key)
      )) {
        this.modalVisible(false);
        this.setState({
          targetStatus: key,
        }, () => {
          this.changeStatus(100);
        })
      } else {
        this.setState({
          dropdownVisible: false,
        });
        this.modalVisible(true);
        if (arr.includes(key) && list.includes(this.state.currentStatus)) {
          this.setState({
            changeModalTitle: 2,
          });
        }
        if (list.includes(key) && arr.includes(this.state.currentStatus)) {
          this.setState({
            changeModalTitle: 1,
          });
        }
      }
    }
    if (workbenchType === 1) {
      this.setState({
        currentTicketKey: key,
      });
    }
    if (workbenchType === 2) {
      this.setState({
        currentOnlineChatKey: key,
      });
    }
    if (workbenchType === 3) {
      this.setState({
        currentPhoneKey: key,
      });
    }
  }

  autoChangeStatus = () => {
    this.setState({
      autoChangeModalVisible: false
    })
  }

  cancelAutoChangeStatus = () => {
    this.setState({
      autoChangeModalVisible: false
    })
  }

  changeStatus = (type: number) => {
    const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
    const { targetStatus, currentTicketKey, currentOnlineChatKey, currentPhoneKey } = this.state;
    let param = {
      workbenchType: newSubStatustType,
      // targetStatus: (newSubStatustType === 3 && targetStatus === 100) ? 110 : targetStatus,
      targetStatus: targetStatus,
      misName: this.props.CommonStore?.UserInfo.username,
      javaLang: getCookie("lang").replace("-", "_")
    }
    if (targetStatus) {
      changeStatusV2(param).then((res: any) => {
        if (res.status === 0) {
          this.init_data(res.data.staffStatusInfo, type);
          this.setState({
            timeoutModalVisible: false,
            dropdownVisible: false,
          });
          if (newSubStatustType === 3) {
            window.parent.postMessage( // 传给genesys的状态
              JSON.stringify({
                type: "setTargetStatus",
                data: { id: this.state.ark2genesys[res.data.staffStatusInfo.currentStatus.toString()]  }
              }),
              "*"
            );
            if (res.data.staffStatusInfo.currentStatus === 1000) {
                getGenesysOutofoffice({ 
                  endDate: moment().startOf('hour').add(1, 'day'),
                  startDate: moment().startOf('hour'),
                  genesysOrganization: this.state.genesysOrganization,
                })
              }
            // if (res.data.staffStatusInfo.currentStatus === 100) {
            //   window.parent.postMessage( // 传给genesys的状态，开始工作时默认在工作中
            //     JSON.stringify({
            //       type: "setTargetStatus",
            //       data: { id: this.state.ark2genesys['100']  }
            //     }),
            //     "*"
            //   );
            // }
          }
          // if (targetStatus === 400 || targetStatus === 500 || targetStatus === 600) {
          //   getActionRecord({workbenchType: newSubStatustType });
          // }
          getActionRecord({workbenchType: newSubStatustType, misName: this.props.CommonStore?.UserInfo.username });
          // 仅用来作用于配合子系统2.1工单处理点击开始工作按钮时，将基座系统与子系统之间状态传递控制触发基座开始工作方法
          if(this.state.changeWorkbenchStatusFromWorkbench){
            dealCurrentStatus(res.data.staffStatusInfo.currentStatusMap[WORK_BENTH_TICKET_TYPE])
        // 仅用来作用于配合子系统2.1工单处理点击开始工作按钮时，将基座系统与子系统之间状态传递控制触发基座开始工作方法后重置为默认值false
            this.setState({
              changeWorkbenchStatusFromWorkbench: false
            })
          }

        } else if (res.status === 10000) {
          message.warning(this.props.CommonStore!.curLocales['CS_Workbench_There_are_wmir'])
          this.init_data(res.data.staffStatusInfo, 100)
        } else {
          if (res.error) {
            message.info(res.error);
            // 当接口异常时，仅用于处理子系统与基座系统特殊功能的方法
            this.resetWorkbenthStatus()
          }
        }
      }).catch(() => {
        // 当接口异常时，仅用于处理子系统与基座系统特殊功能的方法
        this.resetWorkbenthStatus()
      })
    }
    this.modalVisible(false);
    if (type !== 100 || this.state.targetStatus === 1000) {
      this.setCurrentStatus(newSubStatustType, currentTicketKey, currentOnlineChatKey, currentPhoneKey);
    }
  }
  setCurrentStatus = (subStatustType: number, currentTicketKey: number, currentOnlineChatKey: number, currentPhoneKey: number) => {
    let cStatus = this.state.currentStatusMap;
    if (subStatustType === 1) {
      cStatus['1'] = JSON.stringify(currentTicketKey);
      this.setState({
        currentTicketKey,
      });
    }
    if (subStatustType === 2) {
      cStatus['2'] = JSON.stringify(currentOnlineChatKey);
      this.setState({
        currentOnlineChatKey,
      });
    }
    if (subStatustType === 3) {
      cStatus['3'] = JSON.stringify(currentPhoneKey);
      this.setState({
        currentPhoneKey,
      });
    }
    this.setState({
      currentStatusMap: cStatus,
    })
  };
  startWorking = () => {
    const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
    if (this.state.onLine || !navigator.connection) {
      if (this.state.currentStatus !== 1000) {
        this.setState({
          changeModalTitle: 2,
          targetStatus: newSubStatustType === 3 ? 110 : 100,
          dropdownVisible: false,
        });
        this.modalVisible(true);
      } else {
        this.modalVisible(false);
        this.setState({
          targetStatus: newSubStatustType === 3 ? 110 : this.defaultStatusAfterLogin,
          visibleBreakModal: false
        }, () => {
          this.startAfterWorking();
        });
      }
    }
  }
  // 只作用于子系统与基座通信特殊需求，子系统与基座系统之前状态通信的方法
  resetWorkbenthStatus = () => {
    if(this.state.changeWorkbenchStatusFromWorkbench){
      deleteTicketState()
      // 将子系统与基座系统通信标识设置为默认值false
      this.setState({
        changeWorkbenchStatusFromWorkbench: false
      })
    }
  }

  // 判断如果是工单处理页面在操作工单时候切换状态还是需要弹框提示 
  showModalonTicketDealPage = () => {
    // 判断如果在工单列表页时 && 只有在编辑的情况下切换成不可操作工单状态时候才会弹框计时
    if(window.location.href.includes('/ark/ticket-lists') && window.location.href.includes('handle=true')) {
      return true
    } else {
      return false
    }
  }
   handleCancel = () => {
    this.modalVisible(false); 
    this.setState({ targetStatus: this.state.currentStatus })
    // 只作用于子系统与基座通信特殊需求，子系统与基座系统之前状态通信的方法
    this.resetWorkbenthStatus()
  }
  startAfterWorking = () => {
    this.changeStatus(100);
    clearInterval(this.numTiming);
    const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
    if (newSubStatustType === 1) {
      this.setCurrentStatus(newSubStatustType, 100, 1000, 1000);
    }
    if (newSubStatustType === 2) {
      this.setCurrentStatus(newSubStatustType, 1000, 100, 1000);
    }
    if (newSubStatustType === 3) {
      this.setCurrentStatus(newSubStatustType, 1000, 1000, 110);
      getGenesysOutofoffice({ endDate: null, startDate: null, genesysOrganization: this.state.genesysOrganization, });
    }
  }

  dropdownDom = () => {
    const { currentList } = this.state;
    if (currentList && currentList.value) {
      return (<Dropdown placement="bottomCenter" onVisibleChange={(flag) => { this.setState({ dropdownVisible: flag })} } visible={this.state.dropdownVisible} overlayClassName='status-dropdown' trigger={['click']} arrow overlay={(
        <Menu>
          {
           JSON.parse(currentList.value).map((item: { key: number; type: number; title: string; }) => {
              return (
                <Menu.Item key={item.key} onClick={() => this.changeStatusModal(item.key, item.type, currentList.workbenchType)}>
                  <span className={`status ${this.state.currentStatus === item.key ? 'active' : ''}`}>
                    <span className={`circle type-${item.type}`}></span>
                    <span className={'title'}>{item.title}</span>
                  </span>
                </Menu.Item>)
            })
          }
        </Menu>
      )}>
        <span className='curr-status'>
          <span className={`statue-circle type-${this.state.currType}`}></span>
          <span className='title'>{this.state.validStatusMap[this.state.currentStatus]}</span>
          <span className='time'>{getTime(this.state.duration)}</span>
          <CaretDownFilled />
        </span>
      </Dropdown>)
    }
  }

  render() {
    const TEXTS = this.props.CommonStore!.curLocales || {}
    const breakModalEnable =(window.location.href.includes('/ark/work-bench-list') || this.showModalonTicketDealPage() || this.state.onlineStatusActive || this.state.phoneStatusActive);

    return (
      <div>
        {this.state.currentStatusMap ? <div className='working-status-nav'>
          {this.state.currentStatusMap && this.state.currentTicketStatus !== -1 &&
            this.state.validTicketStatusSet && this.state.validTicketStatusSet[0] && this.state.validTicketStatusSet[0].title &&
            <div className={this.state.ticketStatusActive ? 'sub-status-box-active' : 'sub-status-box'}>
              <div className='sub-status' onClick={() => {
                  const { validTStatusSet } = this.state;
                  this.setState({
                    currentList: validTStatusSet,
                  });
                }}>
                <Tooltip placement="bottom" overlayClassName='status-tooltip'
                  // title={<span> {this.state.currentTicketStatus === 101 ? TEXTS['CS_1_Closed_automatic_jUvk'] : TEXTS['CS_1_Open_automatic_PZyZ']}</span>}
                  title={TEXTS['CS_optimazation_Asynchronous_workstations_JwBF']}
                  color='#314F7C'
                >
                  <Badge
                    // status={this.state.currentTicketStatus === 101 ? 'success' : 'error'}
                    color={color[this.state.currentStatusMap['1']]}
                    offset={[-4, 20]}
                  >
                    <IconFont
                      // onClick={this.changeTicketSwitch}
                      onClick={() => {
                        if (!window.location.href.includes('work-bench-list')) {
                          window.open(`//${window.location.host}/fe${this.props.CSVersion ? '/ticket' : ''}/ark_fe?lang=${getCookie("lang")}#/ark/work-bench-list`, "_blank")
                          trackClickEvent('ibt_cs_workstatus_writtenentrance_ck',{
                            "entrance_status" : 'open',
                            "workstatus_version" : '2.0',
                            "workbench_version" : SET_WORKBENCH_VERSION()
                          })
                        }
                      }}
                      className='status-icon' type={'icon-global-list'}
                    />
                  </Badge>
                </Tooltip>
              </div>
            </div>
          }
          {/* 在线客服开关 */}
          {this.state.currentStatusMap && this.state.currentOnlineChatStatus !== -1 &&
            this.state.validOnlineChatStatusSet[0] && this.state.validOnlineChatStatusSet[0].title &&
            <div className={this.state.onlineStatusActive ? 'sub-status-box-active' : 'sub-status-box'}>
              <div className='sub-status' onClick={() => {
                  const { validOStatusSet } = this.state;
                  this.setState({
                    currentList: validOStatusSet,
                  });
                }}>
                <Tooltip placement="bottom" overlayClassName='status-tooltip'
                  // title={<span> {this.state.currentOnlineChatStatus === 121 ? TEXTS['CS_1_Closing_Online_tykf'] : TEXTS['CS_1_Open_Online_umkV']} </span>}
                  title={TEXTS['CS_Workbench_Online_Customer_yXxN']}
                  color='#314F7C'
                >
                  <Badge
                    // status={this.state.currentOnlineChatStatus === 121 ? 'success' : 'error'}
                    color={color[this.state.currentStatusMap['2']]}
                    offset={[-4, 20]}
                  >
                    <IconFont
                      // onClick={this.changeOnlineSwitch}
                      onClick={() => {
                        if (!window.location.href.includes('/fe/im')) {
                          window.open(`//${window.location.host}/fe/im?lang=${getCookie("lang")}#/`, "_blank")
                          trackClickEvent('ibt_cs_workstatus_lcentrance_ck',{
                            "entrance_status" : 'open',
                            "workstatus_version" : '2.0',
                            "workbench_version" : SET_WORKBENCH_VERSION()
                            
                          })
                        }
                      }}
                      className='status-icon' type={'icon-Dialog'} />
                  </Badge>
                </Tooltip>
              </div>
            </div>
          }
          {/* 电话客服 */}
          {  this.state.currentStatusMap && this.state.currentPhoneStatus !== -1 &&
            <div className={this.state.phoneStatusActive ? 'sub-status-box-active' : 'sub-status-box'}>
              <div className='sub-status' onClick={() => {
                  const { validPhoneStatusSet } = this.state;
                  this.setState({
                    currentList: validPhoneStatusSet,
                  });
                }}>
                  <Tooltip placement="bottom" overlayClassName='status-tooltip'
                    // title={<span> {this.state.currentOnlineChatStatus === 121 ? TEXTS['CS_1_Closing_Online_tykf'] : TEXTS['CS_1_Open_Online_umkV']} </span>}
                    title={TEXTS['CS_optimazation_Telephone_workstations_TBZP']}
                    color='#314F7C'
                  >
                    <Badge
                      color={color[this.state.currentStatusMap['3']]}
                      offset={[-4, 20]}
                    >
                      <IconFont
                        onClick={() => {
                          window.open(`//${window.location.host}/fe/ark_fe?lang=${getCookie("lang")}#/ark/genesys`, "_blank")
                          trackClickEvent('ibt_cs_workstatus_phoneentrance_ck',{
                            "entrance_status" : 'open',
                            "workstatus_version" : '2.0',
                            "workbench_version" : SET_WORKBENCH_VERSION()
                          })
                        }}
                        className='status-icon' type={'icon-phone'} />
                    </Badge>
                  </Tooltip>
              </div>
            </div>
          }
          
          {/* 切换工作状态dropdown */}
          {this.dropdownDom()}
          {/* 工作状态改变 提示 */}
          <Modal
            className="change-status-modal"
            visible={this.state.visibleChangeModal}
            onOk={() => {
              if (this.state.changeModalTitle === 2) {
                let newTargetStatus = 100;
                if (this.state.targetStatus === 110) {
                  newTargetStatus = 110;
                } else if (this.state.targetStatus === 1000) {
                  newTargetStatus = 1000;
                } else {
                  newTargetStatus = this.defaultStatusAfterLogin;
                }
                this.setState({
                  targetStatus: newTargetStatus,
                  visibleBreakModal: false,
                }, () => {
                  this.startAfterWorking();
                });
              } else {
                this.changeStatus(200);
              }
            }}
            onCancel={() => { this.handleCancel() }}
            okText={TEXTS.continue}
            cancelText={TEXTS.cancel}
            zIndex={9999}
          >
            <ExclamationCircleOutlined />
            <div>
              <span>{
                (i18nTranslate("CS_optimazation_Make_sure_FVAQ", {
                  workbench_name: window.location.href.includes('/ark/genesys') ? TEXTS['CS_optimazation_Telephone_workstations_TBZP'] :
                  (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? TEXTS['CS_Workbench_Online_Customer_yXxN'] : TEXTS['CS_optimazation_Asynchronous_workstations_JwBF'],
                  status_one: this.state.validStatusMap[this.state.currentStatus],
                  status_two: (this.state.changeModalTitle === 2 && this.state.currentStatus === 100) ? this.state.validStatusMap[100] :
                  this.state.validStatusMap[this.state.targetStatus],
                  status_three: this.state.changeModalTitle === 1 ? this.state.validStatusMap[this.state.targetStatus]
                  : TEXTS['CS_optimazation__akmu']
                }))}</span>
            </div>

          </Modal>
          {/* 休息弹窗   这里的showModalonTicketDealPage方法是处理工单列表页在切换不可操作工单状态是与我的工作台展示弹框逻辑一致 */}
          {breakModalEnable && <Modal
            title="Modal"
            className="working_status_dialog"
            visible={this.state.visibleBreakModal}
            footer={null}
            width={700}
            zIndex={9998}
          >
            {(this.state.currentStatus === 400 || this.state.currentStatus === 500 || this.state.currentStatus === 600) && (
              <div className="time_interval">
                {this.state.currentStatus === 600 ? <span>{TEXTS['CS_Status_In_the_PrHj']}...</span> : <span>{TEXTS['status_' + this.state.currentStatus]}</span>}
                <span className='time'>{getTime(this.state.duration)}</span>
              </div>
            )}
            {(this.state.currentStatus === 1000) && (
              <div className="offwork">
                <span>{TEXTS.welcomeCS}</span>
                <span>{TEXTS.clickStartWorking}</span>
              </div>
            )}

            <Button type="primary" className='start-working' onClick={this.startWorking}>{TEXTS.startWorking}</Button>
          </Modal>}

          {/* 当前服务类型提示 */}
          {breakModalEnable && <ServiceTypeToast visible={this.state.visibleBreakModal} />}

          {/* 自动改变工作状态弹窗 */}
          <Modal
            title="Basic Modal"
            visible={this.state.autoChangeModalVisible}
            onOk={this.autoChangeStatus}
            onCancel={this.cancelAutoChangeStatus}
          >
            <p>{TEXTS[((window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) || window.location.href.includes('/ark/genesys')) ? 'CS_Workbench_Open_the_lnHa' : 'statusChange']}</p>
          </Modal>
          {/* 超时工作状态弹窗 */}
          <Modal
            title={this.state.currentStatus === 100 ? TEXTS['CS_optimazation_Time_out_sqTe'] :
            i18nTranslate("CS_optimazation__zXnN", {
              work_status: this.state.validStatusMap[this.state.currentStatus]
            })}
            visible={this.state.timeoutModalVisible}
            // onCancel={() => {this.setState({ timeoutModalVisible: false, num: this.timeoutNum });}}
            closable={false}
            footer={this.state.currentStatus === 100 ? [
              <Button key="confirm" onClick={() => {
                const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
                this.setState({ timeoutModalVisible: false, num: 0 });
                getActionRecord({workbenchType: newSubStatustType, misName: this.props.CommonStore?.UserInfo.username, });
                clearInterval(this.numTiming);
              }}>
                {`${TEXTS.continue}（${this.state.num}）`}
              </Button>
            ] : [
              <Button key="confirm" onClick={() => {
                const newSubStatustType = (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? 2 : window.location.href.includes('/ark/genesys') ? 3 : 1;
                this.setState({ timeoutModalVisible: false, num: 0 });
                getActionRecord({workbenchType: newSubStatustType, misName: this.props.CommonStore?.UserInfo.username, });
                // 重新计算时间
                if (this.state.currentStatus === 400 || this.state.currentStatus === 500 || this.state.currentStatus === 600) {
                  this.changeStatus(300);
                }
                clearInterval(this.numTiming);
              }}>
                {
                  `${i18nTranslate('CS_optimazation__ZkZb', {
                    work_status: this.state.validStatusMap[this.state.currentStatus],
                  })}
                  (${this.state.num}）`
                }
              </Button>,
              <Button key="start" type="primary" onClick={() => {
                // 若5秒内客服未进行任何 操作确认，则系统自动将【所有工作台状态】状态置为离线状态 并弹窗提示。
                // 1、若客服 点击 【开始工作】，系统将状态更改为在线状态，弹窗消失 2、客服点击【继续用餐】，系统状态不做改变（仍为 当前 用餐状态项），弹窗内容替换为原弹窗
                this.setState({
                  targetStatus: 100,
                  visibleBreakModal: false,
                  timeoutModalVisible: false,
                }, () => {
                  this.startAfterWorking();
                });
              }}>
                {TEXTS.startWorking}
              </Button>
            ]}
            zIndex={9999}
          >
            <p>
              { this.state.currType === 1 ? 
                (i18nTranslate('CS_optimazation_You_have_PlRk', {
                  time_duration: this.state.timeoutThreshold,
                  workbench_name: window.location.href.includes('/ark/genesys') ? TEXTS['CS_optimazation_Telephone_workstations_TBZP'] :
                  (window.location.href.includes('/fe/im') && !window.location.href.includes('dashboard')) ? TEXTS['CS_Workbench_Online_Customer_yXxN'] : TEXTS['CS_optimazation_Asynchronous_workstations_JwBF'],
                })) :
                (i18nTranslate('CS_optimazation__work_JhhB', {
                  time_duration: this.state.timeoutThreshold,
                  work_status: this.state.validStatusMap[this.state.currentStatus],
                }))
              }
            </p>
          </Modal>
        </div>: null}
      </div>

    )
  }
}

export default workingStatus